module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAAAsklEQVQ4je2Uyw3CMBBEn9MFF0QfcQNAGSkkSSG5UxZIyE4XwwEjQeKYJRInGGklf3Zmd7ySXdd1lNC27WO5BwZgU0iPQIMkawRJ/k2OlxScpGKnTxDgLHlVshUSqRRM9iFxM7I2W4tWM+dyuvu32LI+iaqVYkX8RX9dNAJ+BbcGxuyNpIOkqM9xTdwZvvOh9H1vFV0qNMN0UGfsv9SFeec1ME5FdykxF0deB7PNFD4BzQ0Jhg7zYc6abgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platform.png
// module id = 511
// module chunks = 2